import PropTypes from 'prop-types';
import React from "react";
import styles from './productionSteps.module.scss';

function getStepClass(index, currentValue) {
    const classes = [styles.middle]
    if (index < currentValue) classes.push(styles.completed)
    else if (index == currentValue) classes.push(styles.active)
    return classes.join(' ')
}

const ProductionSteps = ({ currentStep, items, small }) => {
    return (
        <div className={styles.wrapper}>
            <ul className={small ? styles.smallSteps :styles.steps }>
                {items.map((data, index) => {
                    return (
                        <li className={styles.step} key={index}>
                            <div className={styles.content}>{data.title}</div>
                            <div className={styles.indicatorWrapper}>
                                <a className={getStepClass(data.status, currentStep)} >
                                    <div className={styles.inner} >{data?.icon}</div>
                                </a>
                            </div>
                        </li >
                    )
                })}
            </ul >
        </div >
    )
}

ProductionSteps.propTypes = {
    currentStep: PropTypes.number,
    items: PropTypes.array,
    small: PropTypes.bool
}

export default ProductionSteps